/* eslint-disable eqeqeq */
import moment from "moment"
import { PaymentMethodType, formatCurrency } from "../../../service/common"
import { PayNowType } from "../../../types"
import { BackToDashboard } from "./back-to-dashboard"
import { useEffect, useState } from "react"
import { connectSocket } from "../../../service/socket.service"
import { useSelector } from "react-redux"
import { selectContractDetails } from "../../../redux/selectors/contracts.selector"
import { RootState } from "../../../redux/reducers"
const socket = connectSocket();

interface PaymentSuccessProps {
  paid_amount: number,
  payment_source_type: number | undefined,
  active_modal_type: string | null,
  new_date_info: any,
  addedCreditFee?:boolean,
  creditReportingFee?:number
}

const initiaType = {
  INITIATED: 'initiated',
  COMPLETED: 'completed'
}
export const PaymentSuccessComponent = ({ paid_amount, payment_source_type, active_modal_type, new_date_info ,addedCreditFee,creditReportingFee }: PaymentSuccessProps) => {
  const [updatePaymentText, setUpdatePaymentText] = useState(initiaType.INITIATED);
 const { selectedContractDetails} = useSelector((state: RootState) => selectContractDetails(state));
  useEffect(() => {
    socket.on("PAYMENT_SUCCESS", (data) => {
      setUpdatePaymentText(initiaType.COMPLETED);
    });

  }, [])
  return (
    <>
      <div className="d-flex flex-column align-items-center px-4 m-0 mb-2 text-center">
        <img src={`../../assets/${payment_source_type === PaymentMethodType.BANK ? (active_modal_type === PayNowType.CHANGE_PAYMENT_DATE ? 'images/clock-orange-circle.png' : 'card-type/bank-clock.png') : `images/${updatePaymentText === initiaType.INITIATED ? 'clock-orange-circle.png' : 'green-circle.svg'}`}`} className="mb-3" alt="icon" />
        {active_modal_type != PayNowType.CHANGE_PAYMENT_DATE &&
          <>
            <p className="fs-20 fw-700">
              Payment of ${formatCurrency(paid_amount + (addedCreditFee ? creditReportingFee ?? 0 : 0) )} has been <br />{" "}
              {payment_source_type === PaymentMethodType.BANK ? 'initiated' : updatePaymentText} successfully.
            </p>
            <p className="fs-16 fw-400">
              {payment_source_type != PaymentMethodType.BANK ?
                <>
                  Thank you for your payment. For any <br /> questions or assistance, please contact our <br /> support team.
                </> :
                <>
                  Your payment has been initiated and is expected to be processed within 5–7 business days.
                </>}
            </p>
          </>
        }
        {
          active_modal_type === PayNowType.CHANGE_PAYMENT_DATE &&
          <>
            <p className="fs-20 fw-700 lh-base">
              {new_date_info.amount > 0 ? (
                <>
                  {" "}
                  Payment of $
                  {formatCurrency(Number(new_date_info.amount) + Number(Number(new_date_info.late_fee_ob.late_fee) * Number(new_date_info.late_fee_ob.missing_payments)))}{" "} has been <br />{" "}
                  {payment_source_type === PaymentMethodType.BANK ? "initiated" : updatePaymentText}{" "} successfully.{" "}
                </>
              ) : (
                <>Payment date updated successfully</>
              )}
            </p>
            <div className="fs-16 fw-700 lh-lg px-4 py-1 radius-8 d-flex align-items-center new-date-wrapper mb-3">
              <img src="../../assets/images/green-calendar.png" className="me-2" alt="" />
              <p className="fs-16 fw-700 lh-lg m-0">
                New Payment Date: {moment(new_date_info.newDate).format('MM/DD/YYYY')}
              </p>
            </div>
            {selectedContractDetails && selectedContractDetails.dnd == 1 && 
            <p className="fs-16 fw-700 text-warning">
              Note: Email not sent. The customer or the selected contract is marked as Do Not Disturb (DND)
            </p>
            }
          </>
        }
      </div>
      <div className="mb-4">
        <BackToDashboard />
      </div>
    </>
  )
}
